import axios from 'axios';
import { message } from 'antd';
import apiError from './apiError';

const request = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:9002/app',
  timeout: 10000,
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    const res = response.data;

    // 如果返回的状态码不是 0，说明有错误
    if (res.code !== undefined && res.code !== 0) {
      // 401: Token 过期或未登录
      if (res.code === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }

      // 广播业务错误
      apiError.emit(res.message || '请求失败');

      return Promise.reject(new Error(res.message || '请求失败'));
    }

    return res;
  },
  (error) => {
    console.error('请求错误:', error);

    let errorMessage = '请求失败';

    if (error.response) {
      const { status, data } = error.response;

      switch (status) {
        case 401:
          errorMessage = '未授权，请重新登录';
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/login';
          break;
        case 403:
          errorMessage = '拒绝访问';
          break;
        case 404:
          errorMessage = '请求资源不存在';
          break;
        case 500:
          errorMessage = data?.message || '服务器错误';
          break;
        default:
          errorMessage = data?.message || '请求失败';
      }
    } else if (error.request) {
      errorMessage = '网络错误，请检查网络连接';
    } else {
      errorMessage = error.message || '请求配置错误';
    }

    // 创建一个新的 error 对象，包含友好的错误消息
    const newError = new Error(errorMessage);
    newError.response = error.response;
    newError.request = error.request;

    // 广播 HTTP 错误
    apiError.emit(errorMessage);

    return Promise.reject(newError);
  }
);

export default request;
